import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OpsExcRecordImpl } from "../model/impl/OpsExcRecordImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class OpsExcRecordImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: OpsExcRecordImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(1),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.stamp != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(2),
        false,
        encodable.stamp,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.dealId != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(3),
        false,
        encodable.dealId,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingUti != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(4),
        false,
        encodable.bookingUti,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(5),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.resolvingUserId != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(6),
        false,
        encodable.resolvingUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.resolvingData != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(7),
        false,
        encodable.resolvingData,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.clearingUserId != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(8),
        false,
        encodable.clearingUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.clearingData != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(9),
        false,
        encodable.clearingData,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.capabilitiesData != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(10),
        false,
        encodable.capabilitiesData,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.payloadData != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(11),
        false,
        encodable.payloadData,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.exceptionTypeId != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(12),
        false,
        encodable.exceptionTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.descriptionTxt != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(13),
        true,
        encodable.descriptionTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.reasonTxt != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(14),
        true,
        encodable.reasonTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.exceptionState != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(15),
        false,
        encodable.exceptionState,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.createdDt != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(16),
        false,
        encodable.createdDt,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.resolveDt != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(17),
        false,
        encodable.resolveDt,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.autoTimeoutDt != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(18),
        false,
        encodable.autoTimeoutDt,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.clearingDt != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(19),
        false,
        encodable.clearingDt,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.autoActionId != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(20),
        false,
        encodable.autoActionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcRecordImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OpsExcRecordImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.Long"],
    [3, "java.lang.Long"],
    [4, "java.lang.String"],
    [5, "java.lang.Long"],
    [6, "java.lang.Long"],
    [7, "java.lang.String"],
    [8, "java.lang.Long"],
    [9, "java.lang.String"],
    [10, "java.lang.String"],
    [11, "java.lang.String"],
    [12, "com.bcdfx.model.OpsExceptionType"],
    [13, "com.bcdfx.model.Errors"],
    [14, "com.bcdfx.model.Errors"],
    [15, "com.bcdfx.model.OpsExceptionState"],
    [16, "java.util.Date"],
    [17, "java.util.Date"],
    [18, "java.util.Date"],
    [19, "java.util.Date"],
    [20, "com.bcdfx.model.OpsIntAction"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: OpsExcRecordImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.id = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.stamp = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.dealId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.bookingUti = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.orderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.resolvingUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.resolvingData = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.clearingUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.clearingData = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.capabilitiesData = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.payloadData = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.OpsExceptionType = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.exceptionTypeId = <CubiqTS.OpsExceptionType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.descriptionTxt = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.reasonTxt = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.OpsExceptionState = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.exceptionState = <CubiqTS.OpsExceptionState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.createdDt = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.resolveDt = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.autoTimeoutDt = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.clearingDt = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: CubiqTS.OpsIntAction = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.autoActionId = <CubiqTS.OpsIntAction>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcRecordImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,OpsExcRecordImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OpsExcRecordImplEncoder.fidTypeMap.has(fid);
  }
}
